import _ from 'lodash';
import React from 'react';
import i18next from 'i18next';
import CalculatorMultipleSelectInput from '../../../../calculatorInputs/CalculatorMultipleSelectInput';
import CalculatorMultipleValueInput from '../../../../calculatorInputs/CalculatorMultipleValueInput';
import { useFormContext } from 'react-hook-form';

const EqualValue = ({ fieldName, showLabel, availableValueOptions, readOnly = false }) => {
  const { setError, clearErrors } = useFormContext();

  const label = showLabel ? i18next.t('calculator.dialog.create.label.values') : '';
  const placeholder = i18next.t('calculator.dialog.create.placeholder.selectValues');

  const validate = (value) => {
    if (!value?.length) {
      setError(fieldName, {
        type: 'manual',
        message: i18next.t('calculator.errors.criterionValueEmpty'),
      });
      return false;
    }
    clearErrors(fieldName);
    return true;
  };

  const commonProps = {
    fieldName,
    label,
    placeholder,
    isRequired: true,
    uxVariant: 'criteriaInput',
    validate,
  };

  return !_.isEmpty(availableValueOptions) ? (
    <CalculatorMultipleSelectInput
      {...commonProps}
      options={availableValueOptions}
      variant="standard"
      triggerOnContinue
      disabled={readOnly}
    />
  ) : (
    <CalculatorMultipleValueInput {...commonProps} disabled={readOnly} triggerOnContinue/>
  );
};

export default EqualValue;
